import { render, staticRenderFns } from "./grid.vue?vue&type=template&id=134d7a50"
import script from "./grid.vue?vue&type=script&lang=ts"
export * from "./grid.vue?vue&type=script&lang=ts"
import style0 from "./grid.vue?vue&type=style&index=0&id=134d7a50&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports